// Mirrors primus-admin-main's store of the same name. Module-singleton with a
// subscriber Set: Header.jsx's WS listener pushes, the bell dropdown renders.
// Replaces the hardcoded mock array Header.jsx used to carry directly.

let notifications = [];
const listeners = new Set();

function notify() {
  listeners.forEach((fn) => {
    try {
      fn(notifications);
    } catch (e) {
      console.error('notificationsStore listener error', e);
    }
  });
}

export function subscribeNotifications(handler) {
  if (typeof handler !== 'function') return () => {};
  listeners.add(handler);
  handler(notifications);
  return () => {
    listeners.delete(handler);
  };
}

export function addNotification(entry) {
  const n = {
    id: entry.id || String(Date.now()) + Math.random().toString(36).slice(2),
    type: entry.type || 'info',
    title: entry.title || '',
    message: entry.message || '',
    time: entry.time || 'Just now',
    read: false,
  };
  notifications = [n, ...notifications].slice(0, 50);
  notify();
}

export function markAllNotificationsRead() {
  notifications = notifications.map((n) => ({ ...n, read: true }));
  notify();
}

export function markNotificationRead(id) {
  notifications = notifications.map((n) => (n.id === id ? { ...n, read: true } : n));
  notify();
}

export function getNotifications() {
  return notifications;
}
